<template>
    <footer class="mainfooter bg-navy m-0" role="contentinfo">
        <div class="footer-middle">
            <div class="container">
                <div class="row">
                    <div class="col-6 col-md-3">
                        <!--Column1-->
                        <div class="footer-pad">
                            <h4>Entre em contato</h4>
                            <ul class="list-unstyled pb-2">
                                <li>
                                    <router-link to="/contato" target="_blank">
                                        <i class="fa fa-comments-o px-2"></i> Contato</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-6 col-md-3">
                        <!--Column1-->
                        <div class="footer-pad">
                            <h4>Dicas</h4>
                            <ul class="list-unstyled pb-2">
                                <li>
                                    <router-link to="/dicas" target="_blank">
                                        <i class="fa fa-trophy px-2"></i>Sobre o {{ appShortName }}</router-link>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/channel/UCZC-ve4TCMkUq4x9qiYnOfQ" target="_blank">
                                        <i class="fa fa-youtube-play px-2"></i> YouTube</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-6 col-md-3">
                        <!--Column1-->
                        <div class="footer-pad">
                            <h4>Empresa</h4>
                            <ul class="list-unstyled pb-2">
                                <li>
                                    <a href="https://armbd.com.br/?tag=about" target="_blank">
                                        <i class="fa fa-building-o px-2"></i>Sobre a Empresa</a>
                                </li>
                                <li>
                                    <a href="http://mbd.com.br/news/" target="_blank">
                                        <i class="fa fa-newspaper-o px-2"></i>Notícias</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-6 col-md-3">
                        <h4>Siga-nos</h4>
                        <ul class="social-network social-circle">
                            <li><a href="https://www.facebook.com/mbdsolucoes" target="_blank" class="icoFacebook"
                                    title="Facebook"><i class="fa fa-facebook"></i>
                                </a>
                            </li>
                            <li><a href="https://www.linkedin.com/company/1056719" target="_blank"
                                    class="icoLinkedin" title="Linkedin"><i class="fa fa-linkedin"></i>
                                </a>
                            </li>
                            <li><a href="https://www.instagram.com/docxdigitalassinatura/" target="_blank" class="icoInstagram"
                                    title="Instagram"><i class="fa fa-instagram"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 copy">
                        <p class="text-center">&copy; Copyright {{new Date().getFullYear()}} - MBD Informática. All
                            rights reserved.</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
    export default {

    }
</script>
<style scoped src="@/assets/sass/bootstrap4.css"></style>
<style scoped>
    footer {
        background: #16222A;
        background: -webkit-linear-gradient(59deg, #3A6073, #16222A);
        background: linear-gradient(59deg, #3A6073, #16222A);
        color: white;
        margin-top: 100px;
    }

    footer a {
        color: #fff;
        font-size: 14px;
        transition-duration: 0.2s;
    }

    footer a:hover {
        color: #007bff;
        text-decoration: none;
    }

    .copy {
        font-size: 12px;
        padding: 10px;
        border-top: 1px solid #FFFFFF;
    }

    .footer-middle {
        padding-top: 2em;
        color: white;
    }


    /*SOCİAL İCONS*/

    /* footer social icons */

    ul.social-network {
        list-style: none;
        display: inline;
        margin-left: 0 !important;
        padding: 0;
    }

    ul.social-network li {
        display: inline;
        margin: 0 5px;
    }


    /* footer social icons */

    .social-network a.icoFacebook:hover {
        background-color: #3B5998;
    }

    .social-network a.icoLinkedin:hover {
        background-color: #007bb7;
    }

    .social-network a.icoFacebook:hover i,
    .social-network a.icoLinkedin:hover i {
        color: #fff;
    }

    .social-network a.socialIcon:hover,
    .socialHoverClass {
        color: #44BCDD;
    }

    .social-circle li a {
        display: inline-block;
        position: relative;
        margin: 0 auto 0 auto;
        -moz-border-radius: 50%;
        -webkit-border-radius: 50%;
        border-radius: 50%;
        text-align: center;
        width: 30px;
        height: 30px;
        font-size: 15px;
    }

    .social-circle li i {
        margin: 0;
        line-height: 30px;
        text-align: center;
    }

    .social-circle li a:hover i,
    .triggeredHover {
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -ms--transform: rotate(360deg);
        transform: rotate(360deg);
        -webkit-transition: all 0.2s;
        -moz-transition: all 0.2s;
        -o-transition: all 0.2s;
        -ms-transition: all 0.2s;
        transition: all 0.2s;
    }

    .social-circle i {
        color: #595959;
        -webkit-transition: all 0.8s;
        -moz-transition: all 0.8s;
        -o-transition: all 0.8s;
        -ms-transition: all 0.8s;
        transition: all 0.8s;
    }

    .social-network a {
        background-color: #F9F9F9;
    }
</style>